import React from "react";
import "./TabChat.css";

export default function TabChat() {
  return (
    <div className="tab-chat">
      <header className="header col-12">
        <h2>Messages</h2>
      </header>
      <section className="row">
        <header></header>
        <main></main>
        <div className="foot"></div>
      </section>
    </div>
  );
}
